import { render, staticRenderFns } from "./ExpandMenu.vue?vue&type=template&id=60298a51"
import script from "./ExpandMenu.vue?vue&type=script&lang=js"
export * from "./ExpandMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports